
import React from 'react';


import {connect} from 'react-redux';
import html2pdf from 'html2pdf.js';
import LoftyDropdownComponent from '../../components/loftydropdowncomponent';
import LoftyCountDown from '../../components/loftycountdown';
import LoftyCartCarousel from '../../components/loftycartcarousel';
import LoftyThreeCarousel from '../../components/loftythreecarousel';
import LoftyCarouselPlugin from '../../components/LoftyCarouselPlugin';
import LoftyLeaftMap from '../../components/loftyLeaftMaps';
import LoftyAnimatedParticleBackground from '../../components/loftyAnimatedParticleBackground';
import LoftyGoogleLoginComponent from '../../components/loftyGoogleLoginComponent';

import { addLoftyToken, deleteLoftytoken } from '../../actions/auth.actions';


import './servicepage_eng.scss';


// Hamburger
function loftyInitHam() {
  try {
  // eslint-disable-next-line no-restricted-globals
    window.addEventListener('click', (event) => {
      let originPointLeft = '';
      const comp = event.target.className;
      if (comp.includes('menu__btn') || comp.includes('span_middle') || comp.includes('span_before') || comp.includes('span_after')) {
        const res = Array.from(document.getElementsByClassName('menu__box'));
        const spanData = Array.from(document.getElementsByClassName('menu__btn'));
        const closeBtn = Array.from(document.getElementsByClassName('menu__close__btn'));
        spanData.forEach((item) => {
          originPointLeft = item.style.left;
        });
        res.forEach((item) => {
          item.style.left = '0px';
        });
        spanData.forEach((item) => {
          item.style.left = '-300px';
        });
        closeBtn.forEach((item) => {
          item.style.left = '10px';
        });
      } else {
        if (comp === 'menu__box') {
          return;
        }
        if (comp === 'linkshref') {
          return;
        }
        if (comp === 'menu__item') {
          return;
        }
        const res = Array.from(document.getElementsByClassName('menu__box'));
        const spanData = Array.from(document.getElementsByClassName('menu__btn'));
        const closeBtn = Array.from(document.getElementsByClassName('menu__close__btn'));
        res.forEach((item) => {
          item.style.left = '-300px';
        });
        spanData.forEach((item) => {
          item.style.left = originPointLeft;
        });
        closeBtn.forEach((item) => {
          item.style.left = '-100%';
        });
      }
    });
  } catch (error) {
    // console.log(error);
  }
}    
    




const Pservicepage_eng = ({
  match,
  history,
  loftytoken,
  loftyuser,
  addLoftyUserApp,
  deleteLoftytokenApp,
  addLoftyTokenApp,
  
}) => {






  
  setTimeout(() => { loftyInitHam(); }, 2000);

  
  

  
  return (
    <div id="id62fa7cbdfc8b2a0012c15bbe" >

      <div id="igll1i" className="">
      
      <div id="i80ug5" className="">
      
      <div id="" className="contentwrapperanimated ">
      
      <div id="" className="container_animated ">
      
      <input
        name=""
        type="checkbox"
        placeholder=""
        className=""
        id="menu__toggle"
      />
      
      <label id="" className="menu__btn ">
      
      <span className="span_before " id="">
        
      </span>
      
      <span className="span_middle " id="">
        
      </span>
      
      <span className="span_after " id="">
        
      </span>
      
      </label>
      
      <ul id="" className="menu__box ">
        
      <li className="linkshref " id="">
        
      <a
        target=""
        className="menu__item "
        id=""
        href="#"
        type=""
      >
        <>Home</>
      </a>
      
      </li>
      
      <li className="linkshref " id="">
        
      <a
        target=""
        className="menu__item "
        id=""
        href="#"
        type=""
      >
        <>About</>
      </a>
      
      </li>
      
      <li className="linkshref " id="">
        
      <a
        target=""
        className="menu__item "
        id=""
        href="#"
        type=""
      >
        <>Team</>
      </a>
      
      </li>
      
      <li className="linkshref " id="">
        
      <a
        target=""
        className="menu__item "
        id=""
        href="#"
        type=""
      >
        <>Contact</>
      </a>
      
      </li>
      
      <li className="linkshref " id="">
        
      <a
        target=""
        className="menu__item "
        id=""
        href="#"
        type=""
      >
        <>Twitter</>
      </a>
      
      </li>
      
      </ul>
      
      </div>
      
      </div>
      
      </div>
      
      <div id="ia5c5o" className="">
      
      <div className="" id="ileqxj">
        
      <span className="" id="i4d4go">
        <>Acosta's</>
      </span>
      
      </div>
      
      <img
        className=""
        id="i6dzmi"
        src="https://assetsprojects.s3.amazonaws.com/406450il5i9ewct.png"
        alt="undefined"
      />
      
      <div className="" id="im1e0j">
        
      <span className="" id="ixxam4">
        <>Lawfirm & Associates</>
      </span>
      
      </div>
      
      </div>
      
      <div id="iihyd1" className="">
      
      <div className="" id="i0ql2c">
        
      <a
        target="_blank"
        className="link "
        id=""
        href="/service"
        type=""
      >
        <>Spanish</>
      </a>
      
      </div>
      
      <div className="" id="i08uu7">
        
      </div>
      
      <div className="" id="if5ki3">
        
      <a
        target=""
        className="link "
        id=""
        href="/services_en"
        type=""
      >
        <>English</>
      </a>
      
      </div>
      
      </div>
      
      </div>
      
      <div id="i8fj" className="">
      
      <div id="itt4x" className="">
      
      <div id="i8dn6" className="">
      
      <div className="" id="i88ni3">
        <>Our</>
      </div>
      
      </div>
      
      <div id="i7eni" className="">
      
      <div className="" id="im1qvd">
        <>Services</>
      </div>
      
      </div>
      
      </div>
      
      <div id="iulh4" className="">
      
      <div id="ilcz9l" className="">
      
      </div>
      
      <div id="iskol" className="">
      
      <div id="i5irz" className="">
      
      <div id="ivggr" className="">
      
      <div className="" id="ivsc7">
        <>Notarial Matters</>
      </div>
      
      <div id="i47ze" className="">
      
      </div>
      
      </div>
      
      </div>
      
      <div id="ixflv" className="">
      
      <div className="" id="iafs7">
        <>Civil Matters</>
      </div>
      
      <div id="ib9mt" className="">
      
      </div>
      
      <div id="iu9ft" className="">
      
      <div className="" id="if3uf">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="iweju6">
        <>Deeds of Sale.</>
      </span>
      
    <div id="" className="">
    
      <span className="" id="iecnzg">
        <><br />Promise to Sale / Agreement.</>
      </span>
      
    </div>
    
    <div id="" className="">
    
      <span className="" id="inkya1">
        <><br />Mortgage and mortgage cancellation.</>
      </span>
      
    </div>
    
    <div id="" className="">
    
      <span className="" id="in7n4f">
        <><br />Donations.</>
      </span>
      
    </div>
    
      </div>
      
      </div>
      
      </div>
      
      <div id="i2tig6" className="">
      
      <div className="" id="i0vjo">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="i32zid">
        <>Commercial Matters</>
      </span>
      
      </div>
      
      <div id="iyw7tj" className="">
      
      </div>
      
      <div id="ioz3nl" className="">
      
      <div className="" id="ia5u8r">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="i8bnz7">
        <>Establishment, Transformation or Dissolution of Companies (Corporations) (Capital Increase and Reduction).</>
      </span>
      
    <div id="" className="">
    
      <span className="" id="iqmimv">
        <><br />Notarial Acts in General.</>
      </span>
      
    </div>
    
    <div id="" className="">
    
      <span className="" id="ic2b18">
        <><br />Testaments.</>
      </span>
      
    </div>
    
    <div id="" className="">
    
      <span className="" id="iap753">
        <><br />Herences and Legacies.</>
      </span>
      
    </div>
    
      </div>
      
      </div>
      
      </div>
      
      <div id="iy8bhi" className="">
      
      <div className="" id="iyqvpl">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="ijdt4k">
        <>Acts of Voluntary Jurisdiction at Notarial Premises</>
      </span>
      
      </div>
      
      <div id="isflqg" className="">
      
      </div>
      
      <div id="ip3ng3" className="">
      
      <div className="" id="is1op3">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="if0f3z">
        <>Registration and Rectification in the Civil Registry.</>
      </span>
      
    <div id="" className="">
    
      <span className="" id="iy658g">
        <><br />Ad-Perpetuam Informations.</>
      </span>
      
    </div>
    
    <div id="" className="">
    
      <span className="" id="ii0955">
        <><br />Marriages (Authorization of Marriages inside and outside Honduras, Marriage Capitulations).</>
      </span>
      
    </div>
    
    <div id="" className="">
    
      <span className="" id="ibu4kn">
        <><br />Divorce by Mutual Consent.</>
      </span>
      
    </div>
    
    <div id="" className="">
    
      <span className="" id="ilir1u">
        <><br />Union and Separation Acts.</>
      </span>
      
    </div>
    
    <div id="" className="">
    
      <span className="" id="ij2sg4">
        <><br />Authorizations in general.</>
      </span>
      
    </div>
    
    <div id="" className="">
    
      <span className="" id="id2vss">
        <><br />Conciliation and Arbitration.</>
      </span>
      
    </div>
    
    <div id="" className="">
    
      <span className="" id="ixl8pp">
        <><br />Partitioning of Property.</>
      </span>
      
    </div>
    
      </div>
      
      </div>
      
      </div>
      
      <div id="i37k8k" className="">
      
      <div className="" id="ip7h93">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="io761z">
        <>Power of Attorney: Granting, Extension, Substitution and Revocation</>
      </span>
      
      </div>
      
      <div id="i5xsb3" className="">
      
      </div>
      
      <div id="in8bzj" className="">
      
      <div className="" id="ijxrik">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="imt1yo">
        <>Special Power.</>
      </span>
      
    <div id="" className="">
    
      <span className="" id="ifmslq">
        <><br />General Power.</>
      </span>
      
    </div>
    
    <div id="" className="">
    
      <span className="" id="ivhlb9">
        <><br />Power (Administration and Disposition).</>
      </span>
      
    </div>
    
      </div>
      
      </div>
      
      </div>
      
      <div id="isa4mk" className="">
      
      <div className="" id="iohh9g">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="i48ify">
        <>Condominium Property</>
      </span>
      
      </div>
      
      <div id="ijmwrn" className="">
      
      </div>
      
      <div id="irtdos" className="">
      
      <div className="" id="iqer13">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="i9dpwb">
        <>For Constitution, Affectation of the Property.</>
      </span>
      
    <div id="" className="">
    
      <span className="" id="i4m36h">
        <><br />Building Groupings.</>
      </span>
      
    </div>
    
    <div id="" className="">
    
      <span className="" id="ie7qpf">
        <><br />Servitude (Constitution).</>
      </span>
      
    </div>
    
      </div>
      
      </div>
      
      </div>
      
      </div>
      
      <div id="il2jp" className="">
      
      </div>
      
      </div>
      
      <div id="i9d40k" className="">
      
      <div id="i1jsxj" className="">
      
      </div>
      
      <div id="ilparc" className="">
      
      <div id="i8ws06" className="">
      
      <div id="iz9qir" className="">
      
      <div className="" id="i545qf">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="io13ji">
        <>Administrative Matters in General<br /></>
      </span>
      
      </div>
      
      <div id="ic11df" className="">
      
      </div>
      
      </div>
      
      </div>
      
      <div id="iwkent" className="">
      
      <div className="" id="iaqq06">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="iod7bn">
        <>Migratories</>
      </span>
      
      </div>
      
      <div id="i1groc" className="">
      
      </div>
      
      <div id="i71avp" className="">
      
      <div className="" id="ifccq8">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="iqjtw2">
        <>Residences.</>
      </span>
      
    <div id="" className="">
    
      <span className="" id="iw6czl">
        <><br />Work Permits.</>
      </span>
      
    </div>
    
    <div id="" className="">
    
      <span className="" id="i1e06h">
        <><br />Residence Permits on Grounds of Legitimate and Special Purpose.</>
      </span>
      
    </div>
    
    <div id="" className="">
    
      <span className="" id="ilwelj">
        <><br />Legalization of Foreign Companies and Organizations.</>
      </span>
      
    </div>
    
    <div id="" className="">
    
      <span className="" id="igx2uu">
        <><br />Legal Entity.</>
      </span>
      
    </div>
    
    <div id="" className="">
    
      <span className="" id="i5f6pk">
        <><br />Fundations.</>
      </span>
      
    </div>
    
      </div>
      
      </div>
      
      </div>
      
      <div id="iemnxq" className="">
      
      <div className="" id="idf33t">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="ick86t">
        <>Tax, Administrative and Accounting Matters</>
      </span>
      
      </div>
      
      <div id="i5r2wf" className="">
      
      </div>
      
      <div id="iph7ew" className="">
      
      <div className="" id="iqzcrj">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="ig2v8y">
        <>Disputes and Lawsuits.</>
      </span>
      
    <div id="" className="">
    
      <span className="" id="izykce">
        <><br />Financial Statements.</>
      </span>
      
    </div>
    
    <div id="" className="">
    
      <span className="" id="iqlu2n">
        <><br />Representation before the SAR.</>
      </span>
      
    </div>
    
      </div>
      
      </div>
      
      </div>
      
      </div>
      
      </div>
      
      <div id="iaqqq9" className="">
      
      <div id="i7alth" className="">
      
      </div>
      
      <div id="ihssh9" className="">
      
      <div id="i93i73" className="">
      
      <div id="i0ofpg" className="">
      
      <div className="" id="i2808z">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="idp5jx">
        <>Judicial Matters<br /></>
      </span>
      
      </div>
      
      <div id="io5l7g" className="">
      
      </div>
      
      </div>
      
      </div>
      
      <div id="i7x1zj" className="">
      
      <div className="" id="igof0t">
        
      <span className="" id="">
        
      </span>
      <>Divorce. </>
    <div id="" className="">
    
      <br className="" id="" />
      
    </div>
    
    <div id="" className="">
    <>Civil, commercial, labour and administrative lawsuits. </>
    <div id="" className="">
    
      <br className="" id="" />
      
    <div id="" className="">
    <>Complaints, Accusations and Defenses in Criminal Matters. </>
    </div>
    
    <div id="" className="">
    
      <br className="" id="" />
      
    </div>
    
    <div id="" className="">
    <>Representation in Administrative and Judicial Matters in General.</>
    </div>
    
    </div>
    
    </div>
    
      </div>
      
      </div>
      
      </div>
      
      <div id="ipjf3a" className="">
      
      </div>
      
      </div>
      
      <div id="i7xfof" className="">
      
      <div id="i9b58g" className="">
      
      </div>
      
      <div id="isofoo" className="">
      
      <div id="i8wcay" className="">
      
      <div id="iqnwly" className="">
      
      <div className="" id="i7ne5g">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="izejfs">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      <>Family Matters<br /></>
      </span>
      
      </div>
      
      <div id="izmnq1" className="">
      
      </div>
      
      </div>
      
      </div>
      
      <div id="i6zsql" className="">
      
      <div className="" id="i66e7f">
        
      <span className="" id="">
        
      </span>
      <>Child Recognition. </>
    <div id="" className="">
    
      <br className="" id="" />
      
    </div>
    
    <div id="" className="">
    <>Civil Marriage.</>
    </div>
    
      </div>
      
      </div>
      
      </div>
      
      </div>
      
      </div>
      
      <div id="ijk5" className="">
      
      <iframe
        title="Mapa"
        className=""
        id="i0wk"
        frameBorder="0"
        src="https://maps.google.com/maps?&q=Bojangles, McNab Plaza, main street, French Harbour&z=17&t=q&output=embed"
      />
      
      </div>
      
      <div id="ixax" className="">
      
      <div id="if6id8" className="">
      
      <div id="ixamfy" className="">
      
      <img
        className=""
        id="iqx8xl"
        src="https://assetsprojects.s3.amazonaws.com/406450il5i9ewct.png"
        alt="undefined"
      />
      
      </div>
      
      <div id="i9tjsk" className="">
      
      <div id="il22am" className="">
      
      </div>
      
      <div className="" id="igni1j">
        <>Acosta's</>
    <div id="" className="">
    <>Lawfirm </>
    </div>
    
    <div id="" className="">
    <>& Associates</>
    </div>
    
      </div>
      
      </div>
      
      </div>
      
      <div id="iacgmf" className="">
      
      <div className="" id="iu9123">
        
      <span className="" id="iaypss">
        <>Roatán,  Islas de la Bahía </>
      </span>
      
      <br className="" id="i8osim" />
      
      <span className="" id="i36x8h">
        <> Honduras</>
      </span>
      
      <br className="" id="i40iea" />
      
      <span className="" id="ie87k8">
        <>Bojangles, McNab Plaza, main street, French Harbour</>
      </span>
      
      <br className="" id="iha4e8" />
      
      <span className="" id="iaq2t7">
        <>Copyright © Acosta Law Firm 2022. All Rights Reserved.</>
      </span>
      
      </div>
      
      </div>
      
      </div>
      
</div>
  );
}

const mapStateToProps = (state) => state.auth;

const mapDispatchToProps = (dispatch) => ({
 addLoftyTokenApp: (data) => dispatch(addLoftyToken(data)),
 deleteLoftytokenApp: () => dispatch(deleteLoftytoken()),
});


export default connect(mapStateToProps, mapDispatchToProps)(Pservicepage_eng);
  